import React, { useState, useCallback, useMemo } from "react";
import { Link, graphql } from "gatsby";
import Seo from "../components/seo";
import Layout from "../components/layout/layout";
import { BlogCateroyMeta } from "../data/metaData";
import { Col, Container, Row } from "react-bootstrap";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

export const Head = ({ pageContext: { category } }) => (
  <Seo
    title={`${category} - ${BlogCateroyMeta.metaTitle}`}
    description={`${category} - ${BlogCateroyMeta.metaDescription}`}
    ogImage={BlogCateroyMeta.ogImage}
    twitterImage={BlogCateroyMeta.twitterImage}
  />
);

const CategoryList = React.memo(({ pageContext: { category }, data }) => {
  const [maxRange, setMaxRange] = useState(9);

  const Posts = data?.allMdx?.edges;
  const allPostLnth = Posts.length;
  const isMorePost = maxRange < allPostLnth;

  const handleLoadMore = useCallback(() => {
    setMaxRange(prevRange => prevRange + 9);
  }, []);

  const filteredPosts = useMemo(() => {
    return Posts.slice(0, maxRange);
  }, [Posts, maxRange]);

  const getPostUrl = (post) => {
    const isAlternative = post.frontmatter.categories?.includes("Alternatives");
    const isCaseStudy = post.frontmatter.categories?.includes("Case Studies");
    const isEbook = post.frontmatter.categories?.includes("e-Book");
    const slug = post.fields?.slug || ''; // Ensure post.fields.slug is defined

    if (isAlternative) {
      return `/alternatives${slug.replace("/blog", "")}`;
    } else if (isCaseStudy) {
      return `/case-studies${slug.replace("/blog", "")}`;
    }  else if (isEbook) {
      return `/e-book${slug.replace("/blog", "")}`;
    }
    else {
      return slug;
    }
  };

  return (
    <Layout>
      <section className="blog-list-section benefits-section section">
        <Container className="pt-5 pb-4">
          <div className="section-title max-width-950">
            <h1 className="heading h2">
              Category - <span className="text-primary">{category}</span>
            </h1>
          </div>
        </Container>
      </section>
      <section className="blog-list-section section pt-0">
        <Container className="pb-5">
          <Row xs={1} sm={1} md={2} xl={3} className="g-4">
            {filteredPosts.map(({ node }, index) => {
              const imageBlog = getImage(node?.frontmatter?.featured);
              return (
                <Col key={index}>
                  <div className="card blog-list-card">
                    <div className="blog-image">
                      <GatsbyImage loading="lazy" image={imageBlog} width={414} height={250} alt="featured" />
                    </div>
                    <div className="blog-list-content">
                      <div className="article d-flex flex-column flex-fill">
                        <h2 className="blog-title h4 mb-3">
                          {/* <Link to={node.fields.slug} itemProp="url">
                            <span itemProp="headline">{node.frontmatter.title}</span>
                          </Link> */}
                          <Link to={getPostUrl(node)} itemProp="url">
                            <span itemProp="headline">{node.frontmatter.title}</span>
                          </Link>
                        </h2>
                        <p className="blog-content" dangerouslySetInnerHTML={{ __html: node.frontmatter.description || node.excerpt }} itemProp="description" />
                        <div className="mt-auto">
                          <Link to={getPostUrl(node)} itemProp="url" className="btn btn-link px-0 pb-0">
                            <span>Read More</span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
                          </Link>
                        </div>
                      </div>
                      <div className="article-footer">
                        <p className="single-line-meta mb-0">
                          <span>{node.frontmatter.date}</span> <span className="inline-sep">|</span> <span className="category text-primary">{category}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </Col>
              );
            })}
            {isMorePost ? (
              <Col xs={12} sm={12} md={12} xl={12} className="mt-5 pt-4 text-center">
                <button onClick={handleLoadMore} className="btn btn-lg btn-dark-theme btn-max-325">Load More</button>
              </Col>
            ) : (
              <Col xs={12} sm={12} md={12} xl={12} className="mt-5 pt-4 text-center">
                <p>No more results</p>
              </Col>
            )}
          </Row>
        </Container>
      </section>
    </Layout>
  );
});

export default CategoryList;

export const pageQuery = graphql`
query CategoryListQuery($category: String) {
  allMdx(
    sort: { frontmatter: { date: DESC } }
    filter: { frontmatter: { categories: { eq: $category } } }
  ) {
    edges {
      node {
        fields {
          slug
        }
        excerpt(pruneLength: 200)
        frontmatter {
          title
          categories
          date(formatString: "MMMM DD, YYYY")
          modifyDate(formatString: "MMMM DD, YYYY")
          featured {
            childImageSharp {
              gatsbyImageData(width: 414)
            }
          }
        }
      }
    }
  }
}
`;
